import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const vi = {
  IBCorporate: 'IB hội nhóm',
  IBIndividual: 'IB lẻ',
  MAMIndividual: 'MAM cá nhân',
  MAMMasterWithLPOA: 'MAM cá nhân',
  MarkupConfirmation: 'xác nhận đánh dấu',
  UserCorporate: 'User Corporate',
  UserIndividual: 'User Individual',
  UserJoint: 'User Joint',
  account: {
    bankingDetails: 'Thông tin tài khoản ngân hàng',
    createANewAccount: 'Mở tài khoản mới',
    register: 'Đăng ký',
    registerSignInTitle: 'Đã là thành viên ?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Is MAM',
        isSales: 'Is Sales User',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'FTD_UTM Report',
        menuTitle: 'FTD_UTM Report',
      },
    },
  },
  adminSocialTrading: {
    title: 'Social Trading',
    investorAccountDetails: {
      tradingAccountName: 'Tên tài khoản giao dịch',
      balance: 'số dư',
      login: 'đăng nhập',
    },
    masterAccountDetails: {
      copyType: 'Kiểu sao chép',
      groupMappingType: 'Group Mapping Type',
      login: 'đăng nhập',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Thu thập quà tặng sinh nhật của bạn',
    availableTable: {
      bonusSize: 'Kích thước tiền thưởng',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'Record was not found',
    },
    captcha: {
      captchaServerIsUnavailable:
        'Captcha server không có sẵn. Vui lòng tải lại trang và thử lại. Nếu vấn đề này lặp lại nhiều lần vui lòng liên hệ CSKH qua online chat hoặc qua email {{0}}',
    },
    files: {
      fileWasNotUploaded: 'File was not loaded',
    },
    mam: {
      linkIsInactive: 'Used link is not active',
    },
    trading: {
      profitSharingLimitWasExceeded:
        'Xin lưu ý rằng giới hạn tối đa cho việc chia sẻ lợi nhuận đã bị vượt quá. Giới hạn tối đa là {{0}}%.',
      notEnoughMoney:
        'Chúng tôi xin lỗi, nhưng tài khoản giao dịch của bạn không đủ số dư để thực hiện yêu cầu rút tiền. Vui lòng đảm bảo bạn có số dư đủ trước khi thực hiện yêu cầu rút tiền. Xin lưu ý rằng ngoài số dư hiện có, bạn cũng nên xem xét mức đòn bẩy tự do cần thiết cho việc rút tiền.',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'Tài khoản Master hiện tại không đủ điều kiện để sao chép, vui lòng thử lại',
    },
    securityCode: {
      emptyValue: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) không thể để trống hoặc null',
      invalidLength: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) phải chứa {{0}} ký tự',
      invalidMinLength: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) phải chứa ít nhất {{0}} ký tự',
      invalidMaxLength: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) không được vượt quá {{0}} ký tự',
      manyRepeatedValues: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) không được có nhiều hơn {{0}} ký tự lặp lại',
      missingNumericValues: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) phải chứa ký tự số',
      containsNumericValues: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) không được chứa bất kỳ giá trị số nào',
      missingLowerCaseValues: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) phải chứa ký tự thường',
      containsLowerCaseValues:
        'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) không được chứa bất kỳ giá trị chữ thường nào',
      missingUpperCaseValues: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) phải chứa ký tự hoa',
      containsUpperCaseValues:
        'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) không được chứa bất kỳ giá trị chữ hoa nào',
      missingSpecialValues: 'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) phải chứa ký tự đặc biệt',
      containsSpecialValues:
        'Giá trị bảo mật nhập vào (mật khẩu hoặc mã PIN) không được chứa bất kỳ giá trị đặc biệt nào',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'Rất tiếc vì sự bất tiện này, nhưng tài khoản {{0}} đã bị khóa',
      ageIsAboveMaxAllowed: 'Chúng tôi không chấp nhận đơn đăng ký của bất kỳ ai dưới {{0}} tuổi hoặc trên {{1}} tuổi.',
      ageIsUnderMinAllowed: 'Chúng tôi không chấp nhận đơn đăng ký của bất kỳ ai dưới {{0}} tuổi.',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'Field {{0}} is required',
      ibCodeIsIncorrect: "The IB code '{{0}}' is incorrect. Please enter a valid IB code",
      invalidCredentials: 'Tên đăng nhập {{0}} hoặc mật khẩu không hợp lệ',
      invalidLengthOfPhoneNumber: 'The phone number length is invalid, please try again',
      invalidLink: 'The link is invalid',
      invalidPhoneNumberLength: 'Độ dài số điện thoại không hợp lệ. Vui lòng thử lại',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Only latin characters and digits can be used for {{0}} field',
      onlyLatinCharactersCanBeUsed: 'Only latin characters can be used for {{0}} field',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: 'Người dùng {{0}} không tồn tại',
      userEmailAlreadyExists: 'Địa chỉ email đã được đăng kí trên hệ thống',
      userPhoneAlreadyExists: 'Điện thoại người dùng đã được đăng kí trên hệ thống',
      cantUpdateProfileActualStatus: "Can't update account {{0}}, actual status = {{1}}",
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'đưa tệp của bạn vào đây',
    exportFormat: 'định dạng xuất khẩu',
    getCode: 'Lấy mã code',
    hide: 'ẩn',
    limitMessage: '{{limit}} Ký tự còn lại',
    resend: 'Gửi lại',
    seconds: 'sec',
    show: 'biểu lộ',
  },
  headerWithBalance: {
    serverTime: 'thời gian ở máy chủ',
    failedToFetchServerTime: ' lấy thời gian máy chủ thất bại',
    view: 'xem/lượt xem',
  },
  investors: {
    blackList: 'Black List',
  },
  legal: {
    clientAgreement: 'Hợp đồng khách hàng',
    privacyPolicy: 'Chính sách quyền riêng tư',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'Về Master',
    infoFields: {
      ibCode: 'IB code',
    },
  },
  masters: {
    fields: {
      masterNickname: 'Tên đăng nhập Chuyên gia',
      rating: 'Vị trí trong xếp hạng',
    },
  },
  menu: {
    deposit: 'tiền gửi',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked:
        "Tài khoảnngười theo dõi đã bắt đầu sao chép tài khoản chuyên gia '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "Tài khoản người theo dõi đã được tạo. Tài khoản người theo dõi đã bắt đầu sao chép tài khoản chuyên gia '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked:
        "Tài khoản người theo dõi đã dừng sao chép tài khoản chuyên gia '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'Tài khoản chuyên gia đã được sửa đổi. (Phân chia lợi nhuận ={{ProfitSharing}}, phương thức phân bổ ={{AllocationMethod}})',
      MasterAccountWasLinked:
        "Tài khoản người theo dõi '{{InvestorAccountName}}' đã bắt đầu sao chép tài khoản chuyên gia.",
      MasterAccountWasOpened:
        'Tài khoản chuyên gia đã được tạo. (Phân chia lợi nhuận ={{ProfitSharing}}, phương thức phân bổ ={{AllocationMethod}})',
      MasterAccountWasUnlinked:
        "Tài khoản người theo dõi '{{InvestorAccountName}}' đã dừng sao chép tài khoản chuyên gia.",
    },
  },
  modal: {
    error: 'lỗi',
    notification: 'thông báo    ',
    ok: 'được rồi',
  },
  operationHistory: {
    filterName: 'Tìm',
    placeholder: 'Vui lòng nhập',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'doanh thu',
    ibInfo: {
      detailsTitle: 'chi tiết IB',
      nextRebatePayment: 'Thanh toán hoàn lại tiếp theo',
      statistics: {
        closetTradersReport: {
          type: 'loại',
        },
        tradingVolReport: {
          subIb: 'IB tầng dưới',
        },
      },
    },
    ibSettings: {
      referralLinkError:
        'Markups không chính xác! Vui lòng liên hệ với bộ phận hỗ trợ của chúng tôi để nhận được Markups chính xác',
    },
    salesUserInfo: {
      aeCode: 'mã AE',
    },
  },
  profile: {
    adult: 'tôi trên 18 tuổi',
    code: 'Mã code',
    country: 'quốc gia',
    documentsUploaded: 'tài liệu đã tải lên',
    isAgreeWithTermsAndConditions:
      'Bằng cách nhấp vào đây, bạn chấp nhận <0> Điều khoản và Điều kiện </0> của <1> tên sàn giao dịch </1>',
    pleaseValidateAccountToDeposit:
      'thông tin cá nhân của bạn yêu cầu xác minh bởi nhóm tuân thủ {{brokerName}}. Trước khi tiếp tục nạp tiền, bạn cần gửi bản quét ID của mình',
    successChangeDescription: 'Đã lưu thay đổi!',
    warningMessage: {
      profileIsBeingVerified: 'Hồ sơ của bạn đang được xác minh, có thể mất vài giây',
    },
  },
  psp: {
    accountsFetchFailErr: 'tìm kiếm tài khoản thất bại',
    confirmEveryTransaction: 'Xác nhận mọi giao dịch, tiền nạp mất đến 24 giờ',
    deposit: {
      depositForm: {
        accountNameTitle: 'tên tài khoản',
        addressLine2: 'Địa chỉ dòng 2',
        beneficiaryAccountNumberTitle: 'số tài khoản người thụ thưởng',
        beneficiaryBankHint: 'ui lòng chọn số tài khoản ngân hàng',
        beneficiaryBankNameHint: 'Tên Ngân Hàng, ví dụ (Ngân hàng Standard Charted)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'Vui lòng đính kèm tài liệu xác nhận thanh toán nếu cần',
      },
      depositTitle: 'nạp tiền',
      notice: 'tiền gửi chỉ có hiệu lực với tài khoản đã được xác minh',
      warnToSubmitPersonalDetails:
        'Để nạp tiền, vui lòng gửi thông tin cá nhân của bạn. Hãy đảm bảo rằng chúng khớp với dữ liệu trong ID của bạn',
    },
    localAgentTable: {
      login: 'đăng nhập',
    },
    operationsFetchFailErr: 'tìm kiếm hoạt động thất bại',
    operationsTable: {
      documentTitle: 'tài liệu  ',
      operationsTableTitle: 'hoạt đọng gần đây',
      paymentSystemTitle: 'hệ thống thanh toán',
    },
    pluginInfoFetchFailErr: 'tìm thông tin đăng nhập thất bại',
    pluginNotFound: 'đăng nhập không được tìm thấy',
    pluginsFetchFailErr: 'Không tìm nạp được plugin',
    preAuthorizedBanking: 'ngân hàng ủy quyền trước',
    qrCodeCryptoNotice:
      'Mã QR chỉ dùng một lần. Không quét mã này trong ứng dụng tiền điện tử nhiều lần, nếu không thanh toán của bạn sẽ bị tạm ngưng.',
    qrCodeCryptoTitle: 'Mã QR cho ứng dụng tiền điện tử',
    resentOperationsTitle: 'hoạt động gần đây',
    transfer: {
      transactionDetailsTitle: 'chi tiết giao dịch',
      transferForm: {
        amountError: 'số tiền chuyển vượt quá hạn mức cho phép',
        currencyTitle: 'tiền tệ',
      },
    },
    uploadBankStatementWithBankName:
      'taie lên sao kê ngân hàng bao gồm tên ngân hàng, họ tên bạn, số tài khoản ngân hàng',
    uploadPayslip: 'Tải lên phiếu thanh toán của ngân hàng về khoản tiền gửi của bạn',
    uploadYourDocument: ' vui lòng xác nhận tiền nạp của bạn bằng cách tải lên chứng từ ngân hàng',
    withdrawal: {
      notice: 'rút tiền chỉ có hiệu lực với tài khoản đã xác minh',
      withdrawalTitle: 'rút tiền',
      withdrawalForm: {
        bankNameTitle: 'tên ngân hàng',
        beneficiaryCryptoWalletHint: 'Một số ví chứa tiền điện tử sẽ được gửi đến',
        beneficiaryCryptoWalletTitle: 'Ví tiền điện tử của người thụ hưởng',
        confirmTitle: 'xác nhận thông tin rút tiền',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'kiểm tra số CCCD đã trùng với ảnh chưa',
      documentTypeHint: 'vui lòng chắc chắn rằng bạn cung cấp hình ảnh chất lượng cao hoặc bản scan giấy tờ hợp lệ',
      uploadedDocumentsTable: {
        docNameTitle: 'Tên tài liệu',
        documentNumber: 'Số tài liệu nhận biết',
        typeTitle: 'Loại tài liệu',
      },
    },
    profileForm: {
      editProfileTitle: 'Sửa hồ sơ',
      proceedToDeposit: 'Nạp tiền đã được thực hiện',
      saveUserSuccessMessage: 'Hồ sơ được lưu thành công',
      userDetailsErrorMessage: 'Thất bại lấy hồ sơ người dùng',
      verifyPersonalDetails: 'Xác minh thông tin cá nhân',
      verifyProfileBtn: 'Xác minh thông tin',
    },
  },
  socialTradingModal: {
    copyHint:
      'Tài khoản của bạn {{account}} sẽ dừng sao chép Chuyên gia {{oldMaster}} và bắt đầu sao chép Chuyên gia {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'Tài khoản giao dịch',
    accountHistoryForm: {
      closeTimeTitle: 'Gio đóng cửa ',
    },
    changeTradingAccountName: 'Thay đổi tài khoản giao dịch',
    connectedAccounts: 'Tài khoản đã liên kết',
    currency: 'Tiền tệ',
    depositForm: {
      amountTitle: 'Số tiền',
      errorMessage: 'Nạp tiền thất bại',
      successMessage: 'Nạp tiền đã được thực hiện thành công',
    },
    descriptionPlaceholder: 'Nhập đề xuất cho người theo dõi bạn',
    fetchServersErr: 'Lấy máy chủ thất bại',
    ibCode: 'Môi giới giới thiệu',
    notRows: 'không có hàng nào để hiển thị',
    openAccountModalSubTitle: 'Công cụ giao dịch rộng lớn : tiền tệ, kim loại ',
    tradingPlatforms: 'Nền tảng giao dịch',
    transferForm: {
      title: 'chuyển tiền nội bộ',
    },
    withdrawForm: {
      amountTitle: 'Số tiền',
      errorMessage: 'Chưa thể lưu đòn bẩy',
      successMessage: 'Rút tiền thành công',
    },
  },
} satisfies ILocaleLegacy;
